<template>
  <div class="bom">
    <div class="bom_mi">
      <div class="bom_brand">
        <div class="bom_brand-head">
          <img class="bom_mi-logo" src="/static/img/bomlogo.png" alt="" @click="$router.push('/')" />
          <div class="bom_brand-name">Aicredit</div>
        </div>
        <div class="testtwo bom_brand-desc">Мы предоставляем быстрые и надежные микрозаймы онлайн для граждан
          Казахстана.</div>
        <div class="mne">
          <img class="pol" src="/static/img/mastercar.png" alt="" />
          <img class="mnh" src="/static/img/visa.png" alt="" />
        </div>
      </div>
      <div class="bom_micon">
        <div class="bom_micon-text">Информация</div>
        <div class="bom_con-text bom_link"  @click="$router.push('/')">Главная</div>
        <div class="bom_con-text bom_link bom_link-wide" @click="getprivacy">Политика конфиденциальности</div>
        <div class="bom_con-text bom_link" @click="getdocument">документ</div>
        <div class="bom_con-text bom_link" @click="goindex(1)">Вопросы и ответы</div>
        <div class="bom_con-text bom_link" @click="goindex(2)">Обратная связь</div>
      </div>
      <div class="bom_contact">
        <div class="bom_micon-text">Контакт-центр</div>
        <div class="bom_cont bom_phone">
          <div class="bom_cont-text">+7 771 181 23 95</div>
        </div>
        <div class="bom_support-card">
          <div class="bom_support-label">Служба поддержки</div>
          <div class="bom_support-mail">info@mfofinancesolutions.kz</div>
        </div>
      </div>
    </div>
    <div class="bom_line"></div>
    <div class="iug">ТОО «МФО “Finance Solutions”», Лицензия на осуществление микрофинансовой деятельности № 01.21.0017.М, от 20.03.2021года,
выдана Управлением региональных представителей в городе Нур-Султан Агентства Республики Казахстан по регулированию и
развитию финансового рынка.</div>
    <div class="iug">Казахстан, город Алматы, Алмалинский район, Проспект ЖИБЕК ЖОЛЫ, дом 135, н.п. 5м, почтовый индекс 050000</div>
  </div>
</template>


<script>
  export default {
    name: "BomTab",
    props: {
      jumpindex: {
        type: Number,
        default: 0
      },
      jumpurl: {
        type: String,
        default: ''
      }
    },
    data() {
      return {};
    },
    mounted() {},
    methods: {
      goHome() {
        if (this.$route.path === '/') {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
          return
        }
        this.$router.push(this.jumpurl).then(() => {
          this.$nextTick(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          })
        })
      },
      getprivacy() {
        location.href = "https://aicredit.kz/privacypolicy.pdf"
      },
      getdocument() {
        if (this.$route.path === '/conte') {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
          return
        }
        this.$router.push('/conte').then(() => {
          this.$nextTick(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          })
        })
      },
      goindex(e){
        const path = e == 1 ? '/quiz' : '/feedback'

        if (this.$route.path === path) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
          return
        }

        this.$router.push(path).then(() => {
          this.$nextTick(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            })
          })
        })
      }
    },
  };
</script>

<style scoped>
  .bom {
    background: #F7F9F9;
    padding: 0.52rem 1.58rem 0.42rem;
  }

  .bom_mi {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.6rem;
  }

  .bom_brand {
    width: 2.2rem;
  }

  .bom_brand-head {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 0.16rem;
  }

  .bom_mi-logo {
    width: 0.18rem;
    height: 0.18rem;
    margin-right: 0.06rem;
  }

  .bom_brand-name {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.1rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .testtwo {
    color: #7c879b;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.07rem;
    line-height: 0.12rem;
    text-align: left;
  }

  .bom_brand-desc {
    width: 1.78rem;
  }

  .mne {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 0.13rem;
  }

  .pol {
    width: 0.41rem;
    height: 0.26rem;
    margin-right: 0.1rem;
  }

  .mnh {
    width: 0.41rem;
    height: 0.26rem;
  }

  .bom_micon {
    min-width: 1.7rem;
  }

  .bom_micon-text {
    color: #313a4c;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.11rem;
    line-height: 0.15rem;
    margin-bottom: 0.16rem;
  }

  .bom_con-text {
    color: #5d6778;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
    line-height: 0.14rem;
  }

  .bom_link {
    cursor: pointer;
    margin-bottom: 0.08rem;
  }

  .bom_link-wide {
    width: 1.52rem;
  }

  .bom_contact {
    width: 2.1rem;
  }

  .bom_cont {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.13rem;
  }

  .bom_cont-text {
    color: #ef624f;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.14rem;
    line-height: 0.2rem;
  }

  .bom_support-card {
    background: #FFFFFF;
    border-radius: 0.08rem;
    border: 0.01rem solid #F0F0F0;
    padding: 0.09rem;
  }

  .bom_support-label {
    color: #666666;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.06rem;
    margin-bottom: 0.02rem;
  }

  .bom_support-mail {
    color: #333333;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 0.07rem;
  }

  .bom_line {
    height: 0.01rem;
    background: rgba(205, 217, 236, 0.9);
    margin: 0.48rem 0 0.16rem;
  }

  .iug {
    color: #7d8797;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.06rem;
    line-height: 0.1rem;
    text-align: left;
  }

  @media screen and (max-width: 768px) {
    .bom {
      padding: 0.36rem 0.2rem 0.3rem;
    }

    .bom_mi {
      flex-direction: column;
      gap: 0.28rem;
    }

    .bom_brand,
    .bom_micon,
    .bom_contact,
    .bom_brand-desc {
      width: 100%;
    }

    .bom_line {
      margin: 0.32rem 0 0.14rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BomTab.vue